import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface EditOtherOfficeConnectionState {
  /**
   * ### 編集対象メールアドレス
   * URLパラメータでメールアドレスを使用するとセキュリティ的に問題があるので、storeで保持している
   */
  mailaddress: string;
}

/**
 * ### EditOtherOfficeConnection store
 *
 */
@Module({ name: "editOtherOfficeConnection" })
export default class EditOtherOfficeConnection extends VuexModule implements EditOtherOfficeConnectionState {
  mailaddress: string = "";

  @Mutation
  private SET_MAILADDRESS(mailaddress: string): void {
    this.mailaddress = mailaddress;
    return;
  }

  /**
   * ### 編集対象メールアドレスを設定する
   *
   * - { rawError: true }を設定しないと例外発生時に正しくエラーが上位に投げられない
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public setMailaddress(payload: { mailaddress: string }): void {
    this.SET_MAILADDRESS(payload.mailaddress);
    return;
  }
}
